<template>
  <div
    id="super_agi_market_research_activity_analytics"
    class="flex flex-col gap-2"
  >
    <InfoGrid :columns="3">
      <ContainerInfoItem
        v-for="(data, key) in analyticsData"
        source="super_agi_market_research_activity_analytics"
        :key="key"
        :title="data.title"
        :description="range?.label || ''"
        :value="formatAnalyticsValue(data.value, data.unit)"
        :is-loading="data.isLoading"
      />
    </InfoGrid>
  </div>
</template>

<script setup>
import { computed, reactive, onMounted, watchEffect } from "vue";
import {
  formatAnalyticsValue,
  toFetchCompanyCount,
  toFetchContactCount,
  toFetchLeadCount,
} from "@/src/utils/analyticUtils.js";
import {
  analyticActions,
  analyticsUserTypes,
} from "@/src/constants/analyticConstants.js";
import store from "@/src/store/index.js";
import InfoGrid from "@/src/components/info_components/InfoGrid.vue";
import ContainerInfoItem from "@/src/components/info_components/ContainerInfoItem.vue";
import { useAnalyticsRefresh } from "@/src/composables/useAnalyticsRefresh.js";

const range = computed(() => store.getters["analytics/getRange"]);

const analyticsData = reactive({
  companies_researched: {
    title: "Companies researched",
    value: 0,
    isLoading: true,
  },
  contacts_researched: {
    title: "Contacts researched",
    value: 0,
    isLoading: true,
  },
  leads_researched: { title: "Leads researched", value: 0, isLoading: true },
});

const getParams = () => ({
  user_type: analyticsUserTypes.SUPERAGI,
  start_time: range.value?.start,
  end_time: range.value?.end,
});

const updateAnalyticItem = (key, value) => {
  if (analyticsData[key]) {
    analyticsData[key].value = value ?? 0;
    analyticsData[key].isLoading = false;
  }
};

const fetchAnalytics = async () => {
  const params = getParams();
  Object.values(analyticsData).forEach((item) => (item.isLoading = true));

  toFetchCompanyCount({ ...params, action: analyticActions.MARKET_RESEARCH })
    .then((result) => updateAnalyticItem("companies_researched", result))
    .catch(() => updateAnalyticItem("companies_researched", 0));

  toFetchContactCount({ ...params, action: analyticActions.MARKET_RESEARCH })
    .then((result) => updateAnalyticItem("contacts_researched", result))
    .catch(() => updateAnalyticItem("contacts_researched", 0));

  toFetchLeadCount({ ...params, action: analyticActions.MARKET_RESEARCH })
    .then((result) => updateAnalyticItem("leads_researched", result))
    .catch(() => updateAnalyticItem("leads_researched", 0));
};

watchEffect(() => {
  if (range.value) fetchAnalytics();
});

useAnalyticsRefresh(fetchAnalytics, [range]);

onMounted(() => {
  if (range.value) {
    fetchAnalytics();
  }
});
</script>
